/** IPS "Group by" asset class field (`FinancialProduct.primaryAssetClass` vs `secondaryAssetClass`). */
export const MODEL_PORTFOLIO_GROUP_BY = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type ModelPortfolioGroupBy =
  (typeof MODEL_PORTFOLIO_GROUP_BY)[keyof typeof MODEL_PORTFOLIO_GROUP_BY];

export const DEFAULT_MODEL_PORTFOLIO_GROUP_BY =
  MODEL_PORTFOLIO_GROUP_BY.PRIMARY;
